const APP_FLAVORS = {
  free: {
    id: "free",
    name: "Community Edition",
    tagline: "Create, explore, and collaborate with the free toolkit.",
    description:
      "The Community Edition keeps the Google/Firebase auth flow, in-app pro upsell, and softly encourages sharing designs with the upcoming community hub.",
    unlocksPro: false,
    hideUpgradeCta: false,
    badges: ["Community Edition", "Free forever"],
    userArea: {
      showCommunityToggles: true,
      showTeamCTA: true,
      allowAnonymousPublishing: true,
    },
    theme: {
      accent: "#2563eb",
      good: "#16a34a",
      hero: "#eff6ff",
    },
  },
  premium: {
    id: "premium",
    name: "Studio Edition",
    tagline: "Everything included. Designed for agencies and power users.",
    description:
      "Studio Edition ships as a paid build. All premium tools stay unlocked, upgrade prompts disappear, and we highlight onboarding plus support details.",
    unlocksPro: true,
    hideUpgradeCta: true,
    badges: ["Studio Edition", "All features unlocked"],
    userArea: {
      showCommunityToggles: true,
      showTeamCTA: false,
      allowAnonymousPublishing: false,
    },
    theme: {
      accent: "#a855f7",
      good: "#14b8a6",
      hero: "#f3e8ff",
    },
  },
};

const KNOWN_FLAVORS = Object.keys(APP_FLAVORS);

const readFlavorFromEnv = () => {
  if (typeof import.meta !== "undefined" && import.meta.env?.VITE_APP_FLAVOR) {
    return import.meta.env.VITE_APP_FLAVOR;
  }
  if (typeof process !== "undefined") {
    const envFlavor =
      process.env?.REACT_APP_APP_FLAVOR ||
      process.env?.APP_FLAVOR ||
      process.env?.VITE_APP_FLAVOR;
    if (envFlavor) return envFlavor;
  }
  return "free";
};

const sanitizeFlavor = (value) => {
  if (!value) return "free";
  const normalized = value.toString().trim().toLowerCase();
  return KNOWN_FLAVORS.includes(normalized) ? normalized : "free";
};

export const ACTIVE_FLAVOR = APP_FLAVORS[sanitizeFlavor(readFlavorFromEnv())];
export const isPremiumBuild = ACTIVE_FLAVOR.unlocksPro;
export const shouldHideUpgradeUi = ACTIVE_FLAVOR.hideUpgradeCta;
export const activeFlavorId = ACTIVE_FLAVOR.id;

export const getFlavorBadgeCopy = () => ACTIVE_FLAVOR.badges;
export const getFlavorTagline = () => ACTIVE_FLAVOR.tagline;
export const getFlavorDescription = () => ACTIVE_FLAVOR.description;
export const getFlavorTheme = () => ACTIVE_FLAVOR.theme || {};
export const getFlavorUserAreaConfig = () => ACTIVE_FLAVOR.userArea || {};

